import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/sagas/userMenu/userMenu";
import { Moon, Sun } from "../../../../../assets/images/svg";

export function ThemeToggle() {
  const dispatch = useDispatch();
  const lightTheme = useSelector((state) => state.userMenu.lightTheme);

  const toggleLightTheme = (event) => {
    let classNameToUpdate = event.target.checked ? "light" : "dark";
    let classNameToRemove = classNameToUpdate === "light" ? "dark" : "light";

    document.body.classList.remove(classNameToRemove);
    document.body.classList.add(classNameToUpdate);
    dispatch(actionCreators.updateThemePreferences(classNameToUpdate));
  };

  return (
    <li className="theme-toggle">
      <div className="theme-toggle__title">Mode</div>
      <div className="theme-toggle__main">
        <div className="theme-toggle__icon">
          <Moon />
        </div>
        <div className="theme-toggle__checkbox">
          <input
            type="checkbox"
            className="ios8-switch"
            onChange={toggleLightTheme}
            checked={lightTheme}
            id="theme"
          />
          <label
            htmlFor="theme"
            style={{
              top: "4px",
              left: "7px",
              position: "relative"
            }}
          />
        </div>
        <div className="theme-toggle__icon theme-toggle__icon-sun">
          <Sun />
        </div>
      </div>
    </li>
  );
}
